
















import Vue from 'vue'

export default Vue.extend({
  inheritAttrs: false,
  name: 'XForm',
  props: {
    onSubmit: {
      type: Function,
      required: false,
    },
  },
  methods: {
    observer() {
      const { observer } = this.$refs as any
      return observer
    },
    reset() {
      this.observer().reset()
    },
    async validate(silent = true) {
      return await this.observer().validate({ silent })
    },
  },
})
